import React from 'react';
import Thead from "components/table/components/thead";
import Tbodycontract
    from "components/table/components/tbodycontract";
import ScrollableTableWrapper from "components/table/components/ScrollableTableWrapper";

const TableContract = ({champsHeader, champsBody, isWaiting, onMissionClick, filterStatus, showPerimeter = false}) => {
    return (
        <ScrollableTableWrapper className="overflow-y-visible w-full">
            <table className="jbz-table table-auto w-full min-w-[1200px] text-gray-500 space-y-6 ft-sm">
                <thead className="sticky top-0 z-10">
                <Thead champsHeader={champsHeader}/>
                </thead>
                <tbody className={isWaiting ? 'animate-pulse' : undefined}>
                {
                    isWaiting ? (
                        <>
                            {[1, 2, 3, 4, 5].map((i, index) => (
                                <tr key={index}>
                                    {/* N° de contrat */}
                                    <td className="py-5 pl-4 pr-2 min-w-[120px]">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* Intérimaire */}
                                    <td className="py-5 px-2 min-w-[250px]">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* Mission */}
                                    <td className="py-5 px-2 min-w-[300px]">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* N° de mission */}
                                    <td className="py-5 px-2">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* Statut */}
                                    <td className="py-5 px-2 min-w-[100px]">
                                        <div className="h-6 bg-gray-200 rounded w-20"></div>
                                    </td>
                                    {showPerimeter && (
                                        <td className="py-5 px-2">
                                            <div className="h-4 bg-gray-200 rounded w-24"></div>
                                        </td>
                                    )}
                                    {/* Date */}
                                    <td className="py-5 px-2">
                                        <div className="h-4 bg-gray-200 rounded w-24"></div>
                                    </td>
                                    {/* Action */}
                                    <td className="py-5 pl-2 pr-3">
                                        <div className="h-8 w-8 bg-gray-200 rounded"></div>
                                    </td>
                                </tr>
                            ))}
                        </>
                    ) : (
                        <>
                            <Tbodycontract champsBody={champsBody} filterStatus={filterStatus} showPerimeter={showPerimeter}/>
                        </>
                    )
                }
                </tbody>
            </table>
        </ScrollableTableWrapper>
    );
};

export default TableContract;